import api from './api';

const petTypesService = {
  getAll: async () => {
    const response = await api.get('/pet-type/get-pet-type');
    return response.data.data || response.data;
  },

  create: async (formData) => {
    const response = await api.post('/pet-type/add-pet-type', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data || response.data;
  },

  update: async (id, formData) => {
    const response = await api.put(`/pet-type/update-pet-type/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data || response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/pet-type/delete-pet-type/${id}`);
    return response.data;
  },
};

export default petTypesService;
